import React, { Component } from "react";
import moment from "moment";
import TextareaAutoajustable from "../../Comunes/TextareaAutoajustable/TextareaAutoajustable";
class PersonaSugef extends Component {
  render() {
    const data = this.props.PersonaSugef;
    const dataEntidad = this.props.PersonaEntidad;
    const EsVisible = this.props.VisiblePersonafisica;

    return (
      <div className="card shadow mb-4">
        <div className="card-header">
          <h6 className="m-0 font-weight-bold text-primary">
            {this.props.Titulo}
          </h6>
        </div>
        <div className="card-body text-gray-800">
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.TipoPersona.Codigo"
                className="col-form-label"
              >
                Tipo Persona
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  data.identificacionPrincipal.tipoPersona.descripcionLarga !==
                  dataEntidad.identificacionPrincipal.tipoPersona
                    .descripcionLarga
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.TipoPersona.Codigo"
                value={
                  data.identificacionPrincipal.tipoPersona.descripcionLarga
                }
                readOnly
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              display: EsVisible && data.tipoExtranjero != null ? "" : "none",
            }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.TipoExtranjero.Id"
                className="col-form-label"
              >
                Tipo Extranjero
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  data.tipoExtranjero?.descripcion !==
                  dataEntidad.tipoExtranjero?.descripcion
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.TipoExtranjero.Id"
                value={data.tipoExtranjero?.descripcion ?? ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.IdentificacionPrincipal.Codigo"
                className="col-form-label"
              >
                Identificación
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  data.identificacionPrincipal.codigo !==
                  dataEntidad.identificacionPrincipal.codigo
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.IdentificacionPrincipal.Codigo"
                value={data.identificacionPrincipal.codigo}
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.NombreORazonSocial"
                className="col-form-label"
              >
                Nombre / Razón Social
              </label>
            </div>
            <div className="col-md-9">
              <TextareaAutoajustable
                className={
                  data.nombreORazonSocial !== dataEntidad.nombreORazonSocial
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.NombreORazonSocial"
                value={data.nombreORazonSocial}
                style={{
                  textTransform: "uppercase",
                }}
                readOnly
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.PrimerApellido"
                className="col-form-label"
              >
                Primer Apellido
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  (data.primerApellido ?? "") !==
                  (dataEntidad.primerApellido ?? "")
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.PrimerApellido"
                value={data.primerApellido ?? ""}
                readOnly
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.SegundoApellido"
                className="col-form-label"
              >
                Segundo Apellido
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  (data.segundoApellido ?? "") !==
                  (dataEntidad.segundoApellido ?? "")
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.SegundoApellido"
                value={data.segundoApellido ?? ""}
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.FechaConstitucionONacimiento"
                className="col-form-label"
              >
                Fecha Nac. / Const.
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                id="PersonaSugef.FechaConstitucionONacimiento"
                className={
                  data.fechaConstitucionONacimiento !==
                  dataEntidad.fechaConstitucionONacimiento
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                value={
                  data.fechaConstitucionONacimiento == null
                    ? ""
                    : moment(data.fechaConstitucionONacimiento).format(
                        "DD/MM/YYYY"
                      )
                }
                readOnly
              />
            </div>
          </div>
          <div className="form-group row">
            <div className="col-md-3">
              <label
                htmlFor="PersonaSugef.PaisRegistroONacimiento"
                className="col-form-label"
              >
                País Nac. / Const.
              </label>
            </div>

            <div className="col-md-9">
              <input
                type="text"
                className={
                  data.paisRegistroONacimiento.nombrePais !==
                  dataEntidad.paisRegistroONacimiento.nombrePais
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.PaisRegistroONacimiento"
                value={data.paisRegistroONacimiento.nombrePais}
                readOnly
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{ display: EsVisible ? "" : "none" }}
          >
            <div className="col-md-3">
              <label htmlFor="PersonaSugef.Genero" className="col-form-label">
                Género
              </label>
            </div>
            <div className="col-md-9">
              <input
                type="text"
                className={
                  data.descripcionGenero !==
                  (dataEntidad.descripcionGenero ?? "")
                    ? "form-control border-danger text-danger"
                    : "form-control"
                }
                id="PersonaSugef.Genero"
                value={data.descripcionGenero}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PersonaSugef;
